import TemplateActionType from './templateActionType';

export const createCustomTemplate = (data) => ({
  type: TemplateActionType.CREATE_CUSTOM_TEMPLATE,
  payload: { data },
});

export const getCustomTemplates = (data) => ({
  type: TemplateActionType.GET_CUSTOM_TEMPLATES,
  payload: { data },
});

export const resetTemplates = () => ({
  type: TemplateActionType.RESET_TEMPLATES,
});

export const saveTemplates = (data) => ({
  type: TemplateActionType.SAVE_TEMPLATES,
  payload: { data },
});

export const editCustomTemplate = (data) => ({
  type: TemplateActionType.EDIT_CUSTOM_TEMPLATE,
  payload: { data },
});

export const saveTemplatesTotal = (data) => ({
  type: TemplateActionType.SAVE_TEMPLATES_TOTAL,
  payload: { data },
});

export const deleteCustomTemplate = (data) => ({
  type: TemplateActionType.DELETE_CUSTOM_TEMPLATE,
  payload: { data },
});
